import React, { useEffect, useState } from 'react';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { openBase64Pdf } from '../utils/fileUtils';
import { format } from 'date-fns';

const groepColors = {
  'Groen': '#2D6A4F', 'Geel': '#E67E22', 'Rood': '#C0392B',
  'Blauw': '#2980B9', 'Toekomstheld': '#8E44AD'
};

function UserModal({ user, onClose, onSave }) {
  const [form, setForm] = useState({ ...user });
  const setField = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2 style={{ fontSize: 20 }}>👤 {user.voornaam} {user.achternaam}</h2>
          <button className="btn btn-secondary btn-sm" onClick={onClose}>✕</button>
        </div>

        <div className="tabs" style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 13, color: 'var(--text-3)' }}>{user.email}</div>
        </div>

        <div className="grid-2">
          <div className="field"><label>Voornaam</label>
            <input className="input" value={form.voornaam || ''} onChange={e => setField('voornaam', e.target.value)} /></div>
          <div className="field"><label>Achternaam</label>
            <input className="input" value={form.achternaam || ''} onChange={e => setField('achternaam', e.target.value)} /></div>
        </div>
        <div className="field"><label>Rol</label>
          <select className="input" value={form.role || 'vrijwilliger'} onChange={e => setField('role', e.target.value)}>
            <option value="vrijwilliger">Vrijwilliger</option>
            <option value="admin">Admin</option>
          </select>
        </div>
        <div className="field"><label>Telefoon</label>
          <input className="input" value={form.telefoon || ''} onChange={e => setField('telefoon', e.target.value)} /></div>
        <div className="field"><label>Coach type</label>
          <div className="checkbox-group">
            {['Stem', 'Cream Sport'].map(opt => (
              <div key={opt} className={`checkbox-pill ${(form.coachType || []).includes(opt) ? 'selected' : ''}`}
                onClick={() => {
                  const arr = form.coachType || [];
                  setField('coachType', arr.includes(opt) ? arr.filter(v => v !== opt) : [...arr, opt]);
                }}>{opt}</div>
            ))}
          </div>
        </div>
        <div className="field"><label>Groep</label>
          <div className="checkbox-group">
            {['Groen', 'Geel', 'Rood', 'Blauw', 'Toekomstheld'].map(opt => (
              <div key={opt} className={`checkbox-pill ${(form.groep || []).includes(opt) ? 'selected' : ''}`}
                onClick={() => {
                  const arr = form.groep || [];
                  setField('groep', arr.includes(opt) ? arr.filter(v => v !== opt) : [...arr, opt]);
                }}>{opt}</div>
            ))}
          </div>
        </div>
        <div className="field"><label>Locatie</label>
          <div className="checkbox-group">
            {['Edegem', 'Mortsel', 'Berchem'].map(opt => (
              <div key={opt} className={`checkbox-pill ${(form.locatie || []).includes(opt) ? 'selected' : ''}`}
                onClick={() => {
                  const arr = form.locatie || [];
                  setField('locatie', arr.includes(opt) ? arr.filter(v => v !== opt) : [...arr, opt]);
                }}>{opt}</div>
            ))}
          </div>
        </div>

        {/* Documents */}
        <div style={{ marginTop: 8 }}>
          <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>📄 Documenten</div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {[['cvData', 'cvNaam', 'CV'], ['strafbladData', 'strafbladNaam', 'Strafblad'], ['contractData', 'contractNaam', 'Contract']].map(([dataKey, nameKey, label]) => (
              user[dataKey] ? (
                <button key={dataKey} type="button" className="btn btn-secondary btn-sm"
                  onClick={() => openBase64Pdf(user[dataKey], user[nameKey] || `${label}.pdf`)}>
                  📄 {label}
                </button>
              ) : (
                <span key={dataKey} className="badge badge-red">{label}: ontbreekt</span>
              )
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 24, paddingTop: 16, borderTop: '1px solid var(--border)' }}>
          <button className="btn btn-secondary" onClick={onClose}>Annuleren</button>
          <button className="btn btn-primary" onClick={() => onSave(user.id, form)}>Opslaan</button>
        </div>
      </div>
    </div>
  );
}

export default function AdminVrijwilligers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterGroep, setFilterGroep] = useState('');
  const [filterLocatie, setFilterLocatie] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    loadUsers();
  }, []);

  async function loadUsers() {
    const snap = await getDocs(collection(db, 'users'));
    setUsers(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    setLoading(false);
  }

  async function handleSave(id, data) {
    await updateDoc(doc(db, 'users', id), data);
    setUsers(prev => prev.map(u => u.id === id ? { ...u, ...data } : u));
    setSelectedUser(null);
  }

  const filtered = users.filter(u => {
    const name = `${u.voornaam || ''} ${u.achternaam || ''} ${u.email || ''}`.toLowerCase();
    if (search && !name.includes(search.toLowerCase())) return false;
    if (filterGroep && !(u.groep || []).includes(filterGroep)) return false;
    if (filterLocatie && !(u.locatie || []).includes(filterLocatie)) return false;
    return true;
  });

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <h1 className="page-title">👥 Vrijwilligers</h1>
          <p className="page-subtitle">{users.length} geregistreerde gebruikers</p>
        </div>
      </div>

      <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)', marginBottom: 24 }}>
        <div className="stat-card"><div className="stat-value">{users.length}</div><div className="stat-label">Totaal</div></div>
        <div className="stat-card"><div className="stat-value">{users.filter(u => u.profileComplete).length}</div><div className="stat-label">Profiel compleet</div></div>
        <div className="stat-card"><div className="stat-value">{users.filter(u => u.role === 'admin').length}</div><div className="stat-label">Admins</div></div>
        <div className="stat-card"><div className="stat-value">{users.filter(u => !u.profileComplete).length}</div><div className="stat-label">Profiel onvolledig</div></div>
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
        <input className="input" style={{ maxWidth: 280 }} placeholder="🔍 Zoeken op naam of e-mail..."
          value={search} onChange={e => setSearch(e.target.value)} />
        <select className="input" style={{ maxWidth: 180 }} value={filterGroep} onChange={e => setFilterGroep(e.target.value)}>
          <option value="">Alle groepen</option>
          {['Groen', 'Geel', 'Rood', 'Blauw', 'Toekomstheld'].map(g => <option key={g} value={g}>{g}</option>)}
        </select>
        <select className="input" style={{ maxWidth: 180 }} value={filterLocatie} onChange={e => setFilterLocatie(e.target.value)}>
          <option value="">Alle locaties</option>
          {['Edegem', 'Mortsel', 'Berchem'].map(l => <option key={l} value={l}>{l}</option>)}
        </select>
      </div>

      {loading ? (
        <p style={{ color: 'var(--text-3)' }}>Laden...</p>
      ) : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Vrijwilliger</th>
                <th>Groep</th>
                <th>Locatie</th>
                <th>Coach type</th>
                <th>Status</th>
                <th>Acties</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(user => (
                <tr key={user.id}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <div style={{
                        width: 34, height: 34, borderRadius: '50%',
                        background: 'var(--primary-pale)', color: 'var(--primary)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 13, fontWeight: 600, flexShrink: 0,
                      }}>
                        {user.voornaam?.[0]?.toUpperCase() || user.email?.[0]?.toUpperCase() || '?'}
                      </div>
                      <div>
                        <div style={{ fontWeight: 500 }}>{user.voornaam ? `${user.voornaam} ${user.achternaam || ''}` : '—'}</div>
                        <div style={{ fontSize: 12, color: 'var(--text-3)' }}>{user.email}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                      {(user.groep || []).map(g => (
                        <span key={g} className="badge" style={{ background: (groepColors[g] || '#888') + '20', color: groepColors[g] || '#888' }}>{g}</span>
                      ))}
                    </div>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                      {(user.locatie || []).map(l => <span key={l} className="badge badge-gray">{l}</span>)}
                    </div>
                  </td>
                  <td style={{ fontSize: 13 }}>{(user.coachType || []).join(', ') || '—'}</td>
                  <td>
                    {user.role === 'admin'
                      ? <span className="badge badge-orange">⚙ Admin</span>
                      : user.profileComplete
                        ? <span className="badge badge-green">✓ Compleet</span>
                        : <span className="badge badge-red">⚠ Onvolledig</span>
                    }
                  </td>
                  <td>
                    <button className="btn btn-secondary btn-sm" onClick={() => setSelectedUser(user)}>
                      Bewerken
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {selectedUser && (
        <UserModal user={selectedUser} onClose={() => setSelectedUser(null)} onSave={handleSave} />
      )}
    </div>
  );
}
